var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalesPresentationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55_1539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.4287 65.3613C52.6786 65.3613 65.041 52.9989 65.041 37.749C65.041 22.4992 52.6786 10.1367 37.4287 10.1367C22.1789 10.1367 9.81641 22.4992 9.81641 37.749C9.81641 52.9989 22.1789 65.3613 37.4287 65.3613Z",
    stroke: "#11244F",
    strokeWidth: 3.68164,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0212 28.5451C45.4654 27.581 44.6579 26.7862 43.6851 26.2458C42.7123 25.7054 41.6109 25.4397 40.4987 25.4771H34.3626C32.7352 25.4771 31.1745 26.1236 30.0238 27.2743C28.873 28.4251 28.2266 29.9858 28.2266 31.6132C28.2266 33.2406 28.873 34.8013 30.0238 35.952C31.1745 37.1028 32.7352 37.7492 34.3626 37.7492H40.4987C42.1261 37.7492 43.6868 38.3957 44.8376 39.5465C45.9883 40.6972 46.6348 42.2579 46.6348 43.8853C46.6348 45.5127 45.9883 47.0734 44.8376 48.2242C43.6868 49.3749 42.1261 50.0214 40.4987 50.0214H34.3626C33.2504 50.0588 32.149 49.7931 31.1762 49.2527C30.2034 48.7122 29.3959 47.9174 28.8402 46.9533",
    stroke: "#11244F",
    strokeWidth: 3.68164,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4297 50.0212V56.1572M37.4297 19.3408V25.4769V19.3408Z",
    stroke: "#11244F",
    strokeWidth: 3.68164,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55_1539"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73.6328,
    height: 73.6328,
    fill: "white",
    transform: "translate(0.613281 0.932617)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesPresentationIcon);
export default __webpack_public_path__ + "static/media/sales-presentation-icon.d7b639f34f45b3fbce5e8a6a0c4b165d.svg";
export { ForwardRef as ReactComponent };